import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allAIRecomendation: [],
  loadingAiRecomendation: false,
  isAiRecDataFetched: false,
  loadingAiRecomendationInner: false,
  positiveSTLoader: false,
  positiveSearchTerm: [],
  negetiveSearchTerm: [],
  selectedAdgroups: [],
  selectedKeyword: [],
  selectedCampaigns: [],
  positiveRecentSearchTerm: [],
  keywordRecommendations: {}, // NEW: Store recommendations per keyword
  allDefinitaions: {},
  allExactST: [],
  allSTLevels: [],
  selectedST: [],
  keywordDetails: [],
  negativeKeywordDetails: [],
  selectedPositiveKeywordDefinitions: {},
  selectedNegativeKeywordDefinitions: {},
  selectedSearchTerm: [],
  actionLoader: false,
};

const aiRecomendationTabSlice = createSlice({
  name: "aiRecomandationTab",
  initialState,
  reducers: {
    setAllAIRecomendation: (state, action) => {
      state.allAIRecomendation = action.payload;
    },
    setLoadingAiRecomendation: (state, action) => {
      state.loadingAiRecomendation = action.payload;
    },
    setIsAiRecDataFetched: (state, action) => {
      state.isAiRecDataFetched = action.payload;
    },
    setLoadingAiRecomendationInner: (state, action) => {
      state.loadingAiRecomendationInner = action.payload;
    },
    setPositiveSTLoader: (state, action) => {
      state.positiveSTLoader = action.payload;
    },
    setPositiveSearchTerm: (state, action) => {
      state.positiveSearchTerm = action.payload;
    },
    setNegetiveSearchTerm: (state, action) => {
      state.negetiveSearchTerm = action.payload;
    },
    setSelectedAdgroups: (state, action) => {
      state.selectedAdgroups = action.payload;
    },
    setSelectedKeyword: (state, action) => {
      state.selectedKeyword = action.payload;
    },
    setSelectedCampaigns: (state, action) => {
      state.selectedCampaigns = action.payload;
    },
    setPositiveRecentSearchTerm: (state, action) => {
      state.positiveRecentSearchTerm = action.payload;
    },
    // NEW ACTION: Store recommendations per keyword
    setKeywordRecommendations: (state: any, action) => {
      const { keyword_shared_uid, data } = action.payload;
      state.keywordRecommendations[keyword_shared_uid] = data;
    },
    setAllDefinitaions: (state: any, action) => {
      const { id, row, definition } = action.payload;

      state.allDefinitaions[id] = {
        ...row,
        definition,
      };
    },
    removeDefinition: (state: any, action) => {
      const id = action.payload;
      delete state.allDefinitaions[id];
    },
    resetAllDefinitions: (state: any) => {
      state.allDefinitaions = {};
    },
    setAllExactST: (state: any, action) => {
      state.allExactST = action.payload;
    },
    resetStateOfAiRecomendationTab: () => initialState,
    clearFirstTableState: (state) => {
      state.positiveSearchTerm = [];
      state.negetiveSearchTerm = [];
      state.selectedAdgroups = [];
      state.selectedKeyword = [];
      state.selectedCampaigns = [];
      state.positiveRecentSearchTerm = [];
      state.keywordRecommendations = {};
      state.allDefinitaions = {};
    },
    setAllSTLevels: (state, action) => {
      state.allSTLevels = action.payload;
    },
    setSelectedST: (state, action) => {
      state.selectedST = action.payload;
    },
    setKewordDetails: (state, action) => {
      state.keywordDetails = action.payload;
    },
    setNegativeKeywordDetails: (state, action) => {
      state.negativeKeywordDetails = action.payload;
    },
    setPositiveKeywordDefinitions: (state: any, action) => {
      const { id, row, definition } = action.payload;

      state.selectedPositiveKeywordDefinitions[id] = {
        ...row,
        definition,
      };
    },
    removePositiveDefinition: (state: any, action) => {
      const id = action.payload;
      delete state.selectedPositiveKeywordDefinitions[id];
    },
    setNegativeKeywordDefinitions: (state: any, action) => {
      const { id, row, definition } = action.payload;
      state.selectedNegativeKeywordDefinitions[id] = {
        ...row,
        definition,
      };
    },
    removeNegativeDefinition: (state: any, action) => {
      const id = action.payload;
      delete state.selectedNegativeKeywordDefinitions[id];
    },
    resetDefinitions: (state: any) => {
      state.selectedPositiveKeywordDefinitions = {};
      state.selectedNegativeKeywordDefinitions = {};
    },
    setSelectedSearchTerm: (state, action) => {
      state.selectedSearchTerm = action.payload;
    },
    clearSecondTableState: (state) => {
      state.selectedPositiveKeywordDefinitions = {};
      state.selectedNegativeKeywordDefinitions = {};
      state.selectedSearchTerm = [];
      state.keywordDetails = [];
      state.negativeKeywordDetails = [];
      state.selectedST = [];
      state.allExactST = [];
    },
    setActionLoader: (state, action) => {
      state.actionLoader = action.payload;
    },
  },
});

export const {
  setAllAIRecomendation,
  setLoadingAiRecomendation,
  setIsAiRecDataFetched,
  setLoadingAiRecomendationInner,
  setPositiveSearchTerm,
  setNegetiveSearchTerm,
  setPositiveSTLoader,
  setSelectedAdgroups,
  setSelectedKeyword,
  setSelectedCampaigns,
  setPositiveRecentSearchTerm,
  setKeywordRecommendations,
  resetStateOfAiRecomendationTab,
  setAllDefinitaions,
  removeDefinition,
  resetAllDefinitions,
  clearFirstTableState,
  setAllExactST,
  setAllSTLevels,
  setKewordDetails,
  setNegativeKeywordDetails,
  setPositiveKeywordDefinitions,
  removePositiveDefinition,
  setNegativeKeywordDefinitions,
  removeNegativeDefinition,
  setSelectedSearchTerm,
  resetDefinitions,
  clearSecondTableState,
  setActionLoader,
} = aiRecomendationTabSlice.actions;

export default aiRecomendationTabSlice.reducer;
